import React from 'react';
import Svg, { Polygon, G } from '@dbk/ui-svg';
import { View } from '@dbk/ui-react-utils';

const PlusSign = ({ fill = 'white', width = 15, height = 15, scale = 1, style }) => (
  <View style={style}>
    <Svg width={width} height={height}>
      <G scale={scale}>
        <Polygon
          points="6.3,8.6 0,8.6 0,6.4 6.3,6.4 6.3,0 8.7,0 8.7,6.4 15,6.4 15,8.6 8.7,8.6 8.7,15 6.3,15 "
          fill={fill}
        />
      </G>
    </Svg>
  </View>
);

export default PlusSign;
